<template>
  <v-dialog v-model="dialog" fullscreen style="z-index: 9999999; background: #0f0f0f;" dark>
    <v-card>
      <v-layout row class="player_wrap">
        <v-flex xs12 sm8>
          <v-col class="pa-0 pr-5">

            <div id="videoContainer" ref="playerContainer" class="video-container" style="border-radius:10px"></div>
            <div class="play_title">
              <h2>
                {{ playerName }}
              </h2>
              <v-btn large @click="closeModal" outlined color="#ddd" style="background: #555;">
                <v-icon class="mr-1">mdi mdi-logout</v-icon> {{ $store.getters.t('나가기')}}
              </v-btn>
            </div>
          </v-col>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card class="titlecard" elevation="0">
            <span>Player</span>
            <h2>{{ groupName }}</h2>
          </v-card>

          <v-card v-model="currentVideoIndex" color="black" class="playerlist">
              <v-card v-for="(video, index) in videos" :key="video.uuid" @click="selectVideo(index)" two-line
                class="asset" :class="{ 'selected': index === currentVideoIndex }">
                <div class="list_layout" style="display:flex;">

                  <section style="display: flex; flex-direction: column; justify-content: center;">
                    <div class="image-container ma-1">
                      <img :src="video.image"
                        style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;"
                        :contain="true" />
                    </div>
                  </section>
                  <section class="pa-3 pl-4" style="display: flex; flex-direction: column; justify-content: center;">
                    <span style="word-break:break-all;">
                      {{ video.title }}
                    </span>
                    <div style="color:#aaa" class="mt-2">
                      <v-icon class="mdi mdi-play-circle-outline mr-1" small color="#ccc"></v-icon>
                      <span>{{ video.runtime }}</span>
                    </div>
                  </section>
                </div>
              </v-card>
            </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import PlaylistApi from "@/api/playlist/PlaylistApi";
import OvenPlayer from 'ovenplayer';
import Hls from 'hls.js';

export default {
  props: ['value', 'groupName'],
  
  data() {
    return {
      dialog: this.value,
      videos: [],
      currentPlaylistName: 'Playlist Name',
      playerInstance: null,
      currentVideoIndex: 0,
      playerName: '',
      isVideoPlaying: false
    };
  },
  methods: {
    setGroupId(url) {
      console.log('url', url);
      this.url = url;
    },
    closeModal() {
      this.dialog = false;
      this.videos = [];
      this.currentVideoIndex = 0;
      this.selectedVideoURL = '';
      this.playerName = '';
      this.isVideoPlaying = false;
      this.$emit('input', this.dialog);
      if (this.playerInstance) {
        // console.log('닫기');
        this.playerInstance.remove();
        this.playerInstance = null;
      }
    },
    async modalList(url) {
      if (!this.videos.length) {
        try {
          const response = await PlaylistApi.modalplaylist(url);
          if (response && Array.isArray(response.tracks)) {
            // console.log('res', response);
            this.videos = response.tracks.map(track => ({
              image: track.posterImg ? track.posterImg : "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png",
              runtime: track.runtime,
              title: track.name,
              smil_player_url: track.smil_player_url.trim(),
              sources: [{
                type: 'hls',
                file: track.smil_player_url.trim()
              }]
            }));
            //  console.log("videos => ", this.videos)
            this.initPlayer();
          } else {
            // console.error('api호출 에러', response);
          }
        } catch (error) {
          console.error('Error', error);
        }
      }
    },
    initPlayer() {
      this.playerInstance = OvenPlayer.create('videoContainer', {
        //playlist: this.videos
        playlist: this.videos.map(video => ({
          title: video.title,
          image: video.image, 
          sources: video.sources,
          tracks: video.tracks
        })),
        showBigPlayButton: true,

      });

      this.playerInstance.on('playlistChanged', (index) => {
        this.currentVideoIndex = index;
        this.playerName = this.videos[index].title;

        this.closePlaylist();

        this.isVideoPlaying = false;
        setTimeout(() => {
          this.playerInstance.play();
        }, 300);
      });

      this.playerInstance.on('ready', () => {
        this.playerInstance.play();
      });

      this.playerInstance.on('play', () => {
        this.isVideoPlaying = true;
      });

      this.playerInstance.on('complete', () => {
        if (this.isVideoPlaying) {
          //console.log('비디오준비 현재순서', this.currentVideoIndex);
          if (this.currentVideoIndex < this.videos.length - 1) {
            //console.log('다음으로 이동', this.currentVideoIndex + 1);
            this.currentVideoIndex += 1;
            setTimeout(() => {
              this.selectVideo(this.currentVideoIndex);
            }, 500);
          } else {
            // console.log('Playlist complete');
          }
        }
      });
    },
    closePlaylist() {
      const playlistButton = document.querySelector('.op-close-icon.btn-close');
      if (playlistButton) {
        playlistButton.click();
      } else {
        //console.log('버튼을 찾을 수 없습니다.');
      }
    },
    selectVideo(index) {
      //console.log('비디오 선택', index);
      if (this.playerInstance) {
        this.currentVideoIndex = index;
        
        this.isVideoPlaying = false;
        this.playerInstance.setCurrentPlaylist(index);
        setTimeout(() => {
          this.playerInstance.play();
        }, 300);
        this.playerName = this.videos[index].title;
        //console.log('비디오선택한거 재생', this.videos[index]);
      }
    }
  },
  beforeDestroy() {
    if (this.playerInstance) {
      //console.log('비디오설정 삭제');
      this.playerInstance.remove();
      this.playerInstance = null;
    }
  },
  watch: {
    value(newVal) {
      this.dialog = newVal;
      if (newVal) {
        if (this.url) {
          this.modalList(this.url);
        }

        this.currentVideoIndex = 0;

        if (this.playerInstance) {
          setTimeout(() => {
            this.playerInstance.setCurrentPlaylist(0);
            this.playerInstance.play();
          }, 300);
        }
      }
    },
    dialog(newVal) {
      this.$emit('input', newVal);
      if (newVal) {
        if (this.url) {
          // this.modalList(this.url);
        }
      } else {
        this.closeModal();
      }
    }
  }
};
</script>
<style scoped>
.selected {
  background-color: #777777;
}

.player_wrap { 
  padding: 48px;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.button-icon {
  background-image: url('@/styles/assets/onerepeat_icon.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 24px;
  height: 24px;
  border: none;
  cursor: pointer;
}

.image-container {
  position: relative;
  background-color: black;
  width: 107px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.titlecard { 
  background: #363636;
  border-radius: 16px;
  padding: 24px;
}

.titlecard span { opacity: 0.4; }

.playerlist {  
  margin-top: 16px;
  border-radius: 16px;
  background: #363636;
}

.playerlist .asset {
  background: #363636;
  padding:12px;
  border-radius: 0;
}

.play_title{
  display: flex;
  justify-content: space-between;
  padding-top: 24px;
}
</style>
